import { Col } from "antd"
import DropdownField from "../../DropdownField"
import { useFormContext } from "react-hook-form"
import { getAllowedCampaignTypes, useCurrentUser } from "../../../../utils/CurrentUserContext"
import { isNativeDisplayCampaign } from "../../../../utils/api/campaign"
import { CampaignTargetType, CampaignType } from "../../../../__generated__/graphql"

const CampaignTypeField = ({disabled = false}: {disabled?: boolean}) => {
  const {user} = useCurrentUser()
  const {setValue, watch} = useFormContext()
  const allowedCampaignTypes = getAllowedCampaignTypes(user)
  const campaignType = watch('type')
  const isNativeDisplay = isNativeDisplayCampaign(campaignType)
  const options = isNativeDisplay ? allowedCampaignTypes.nativeDisplay : allowedCampaignTypes.nativeContent
  
  if (options.length <= 1) {
    return null
  }

  return (
    <Col span={12}>
      <DropdownField
        top
        required
        label='Type'
        disabled={disabled}
        options={options}
        htmlfor='type'
        onChange={(newType) => {

          if (newType === CampaignType.Filler) {
            setValue('targetType', CampaignTargetType.Cpm)
          } else {
            setValue('targetType', CampaignTargetType.Budget)
          }

          setValue('targetValue', undefined)
        }}
      />
    </Col>
  )
}


export default CampaignTypeField
